import { AAGUID, OnlinePaymentMethod } from '@interticket/core';
import { Type } from '../type/type.model';
import { IPayment } from '@core/interfaces/payment/payment.interface';

export class Payment implements IPayment {

  readonly id: AAGUID;
  readonly displayName: string;
  readonly type: Type<OnlinePaymentMethod>;

  constructor(iPayment: IPayment) {
    this.id = iPayment.id;
    this.displayName = iPayment.displayName;
    this.type = new Type(iPayment.type);
  }

}
